export const PAGE_SETTINGS_PATH = {
  PRODUCT_MANAGEMENT: 'PRODUCT_MANAGEMENT',
  SUPPLIER_LIST: 'SUPPLIER_LIST',
  FACTORY_LIST: 'FACTORY_LIST',
  PRODUCT_TESTING_ALL: 'PRODUCT_TESTING_ALL',
  DOCUMENT_REVIEW_PAGE: 'DOCUMENT_REVIEW_PAGE',
  DOCUMENT_REVIEW_ALL: 'DOCUMENT_REVIEW_ALL',
  DOCUMENT_REVIEW_MY_JOB: 'DOCUMENT_REVIEW_MY_JOB',
  DOCUMENT_REVIEW_VIEW_ONLY: 'DOCUMENT_REVIEW_VIEW_ONLY',
  QC_INSPECTION_PAGE: 'QC_INSPECTION_PAGE',
  QC_INSPECTION_ALL: 'QC_INSPECTION_ALL',
  QC_INSPECTION_3RD_PARTY: 'QC_INSPECTION_3RD_PARTY',
  QC_INSPECTION_INHOUSE: 'QC_INSPECTION_INHOUSE',
  QC_INSPECTION_DRAFT: 'QC_INSPECTION_DRAFT',
  IQC_PAGE: 'IQC_PAGE',
  IQC_ALL: 'IQC_ALL',
  IQC_CALENDAR: 'IQC_CALENDAR',
  IQC_DRAFT: 'IQC_DRAFT',
  FACTORY_AUDIT_PAGE: 'FACTORY_AUDIT_PAGE',
  FACTORY_AUDIT_JOB: 'FACTORY_AUDIT_JOB',
  FACTORY_AUDIT_DRAFT: 'FACTORY_AUDIT_DRAFT',
};
export const PAGE_SETTINGS_DEFAULT_VALUE = {
  page: 1,
  pageSize: 10,
  mode: 'list',
  search: '',
};
const PAGE_SETTINGS_DEFAULT_STATE = {};
Object.keys(PAGE_SETTINGS_PATH).forEach((key) => {
  PAGE_SETTINGS_DEFAULT_STATE[PAGE_SETTINGS_PATH[key]] = {
    ...PAGE_SETTINGS_DEFAULT_VALUE,
  };
});
export { PAGE_SETTINGS_DEFAULT_STATE };
